import { clientOnlyLazy } from 'components/ClientOnlySuspense/clientOnlyLazy';
import LoadingModal from 'modals/LoadingModal';

export const StaffGradFairInviteModalContainerLoadable = clientOnlyLazy({
  loader: () =>
    import(
      /* webpackChunkName: "StaffGradFairInviteModalContainer" */
      './StaffGradFairInviteModalContainer.dynamic'
    ),
  loading: LoadingModal,
});
